import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from '../../config/axios.config'
import { axiosHeaders } from '../../utils'

export const fetchAllCustomer = createAsyncThunk<
  any,
  { limit?: number; lastEvaluatedSK?: string; type?: string },
  { rejectValue: string | null }
>('customer/getall', async (params, thunkAPI) => {
  try {
    const response: any = await axios.get('/customer/all', {
      ...axiosHeaders(),
      params: params
    })

    if (response.status === 200) {
      return {
        data: response.data.response.data,
        key: response.data.response.lastEvaluatedSK,
        total: response.data.response.totalDataCount,
        type: params.type ? params.type : ''
      }
    } else {
      return thunkAPI.rejectWithValue(response.meta.errorDescription)
    }
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response.data.response)
  }
})

export const saveCustomer = createAsyncThunk<
  any,
  {},
  { rejectValue: string | null }
>('customer/save', async (params, thunkApi) => {
  try {
    const response: any = await axios.post(
      '/customer/save',
      params,
      axiosHeaders()
    )

    if (response.status === 200 && response.data.response === 'success') {
      return { status: 'success' }
    } else {
      return thunkApi.rejectWithValue(response.data.meta.errorDescription)
    }
  } catch (error: any) {
    if (error.response.data.meta.errorDescription) {
      return thunkApi.rejectWithValue(error.response.data.meta.errorDescription)
    }

    return thunkApi.rejectWithValue(error.message)
  }
})

export const removeCustomer = createAsyncThunk<
  any,
  { label: string },
  { rejectValue: string | null }
>('customer/delete', async (params, thunkApi) => {
  try {
    const response: any = await axios.delete(
      '/customer/' + params.label,
      axiosHeaders()
    )

    if (response.status === 200 && response.data.response === 'success') {
      return { status: 'success' }
    } else {
      return thunkApi.rejectWithValue(response.data.meta.errorDescription)
    }
  } catch (error: any) {
    if (error.response.data.meta.errorDescription) {
      return thunkApi.rejectWithValue(error.response.data.meta.errorDescription)
    }

    return thunkApi.rejectWithValue(error.message)
  }
})

export const getCustomer = createAsyncThunk<
  any,
  { label: string },
  { rejectValue: string | null }
>('customer/getdata', async (params, thunkAPI) => {
  try {
    const response: any = await axios.get(
      '/customer/' + params.label,
      axiosHeaders()
    )

    if (response.status === 200) {
      return { data: response.data.response }
    } else {
      return thunkAPI.rejectWithValue(response.meta.errorDescription)
    }
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response.data.response)
  }
})
